module.exports = __webpack_public_path__ + "static/media/og05.8f09a288.webp";